import { useAuth } from '../context/AuthContext';
import { LoadingBlock } from '../components/ui';
import { RsvpPage } from './RsvpPage';

/**
 * Invitasjonen slik gjestene ser den.
 *
 * Åpnes i en egen fane fra gjestelista, uten menyen rundt – poenget er å se
 * siden slik den faktisk er, og en sidemeny langs kanten ville vært med på
 * bildet uten å høre hjemme der.
 */
export function InvitasjonForhandsvisning() {
  const { activeWedding } = useAuth();
  if (!activeWedding) return <LoadingBlock label="Henter invitasjonen …" />;
  return <RsvpPage forhandsvisningFor={activeWedding.id} />;
}
